export enum CommissionPartyRole {
  MobileWalletPLC = 0,
  Partner = 1,
  Investor = 2,
  PartnerSubInvestor = 3,
  LocationProvider = 4,
  MgmtCompany = 5,
  LiquidityProvider = 6,
}
